import { Extension } from '@tiptap/core';


declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    hello: {
      insertNotification: (notification: string) => ReturnType
    }
  }
}

export const NotificationExtension = Extension.create({
  name: 'NotificationActions',

  addCommands() {
    return {
      insertNotification:
        (notification: string) =>
        ({ commands }) => {
          return commands.insertContent(`${notification}`)
        },
    }
  },
})